/** Format milliseconds as M:SS (or H:MM:SS for ≥ 1h). */
export function fmtDur(ms: number): string {
  const totalSec = Math.round(ms / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  const ss = String(s).padStart(2, '0');
  if (h > 0) return `${h}:${String(m).padStart(2, '0')}:${ss}`;
  return `${m}:${ss}`;
}

/** Total runtime of an array of tracks, formatted as "53 min" or "1 h 12 min". */
export function fmtTotalRuntime(msTotal: number): string {
  const min = Math.round(msTotal / 60000);
  if (min < 60) return `${min} min`;
  const h = Math.floor(min / 60);
  const rem = min % 60;
  return `${h} h ${String(rem).padStart(2, '0')} min`;
}
